var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrowWith2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 83,
    viewBox: "0 0 83 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 82,
    height: 82,
    rx: 9.5,
    fill: "white",
    stroke: "#E2E4E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.0391 28.126L33.1457 29.2326C35.494 26.8842 38.679 25.5649 42.0001 25.5649C45.3212 25.5649 48.5062 26.8842 50.8545 29.2326L51.9611 28.126C49.3193 25.4842 45.7362 24 42.0001 24C38.264 24 34.6809 25.4842 32.0391 28.126Z",
    fill: "#3070A0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.9996 30.2607C39.9235 30.258 37.9319 31.083 36.4658 32.553L37.5724 33.6596C38.7466 32.4854 40.3391 31.8257 41.9996 31.8257C43.6602 31.8257 45.2527 32.4854 46.4269 33.6596L47.5335 32.553C46.0674 31.083 44.0758 30.258 41.9996 30.2607Z",
    fill: "#3070A0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.4782 52.1739V49.6077L45.6657 49.0027C45.458 48.9331 45.289 48.7796 45.1997 48.5795C45.1105 48.3795 45.1092 48.1512 45.1961 47.9501L47.4782 42.6832V41.2173C47.4681 38.103 48.8895 35.1568 51.3334 33.2264C53.7773 31.296 56.9726 30.5956 59.9999 31.3267V59.2173H53.7391V55.3043H50.6086C48.8797 55.3043 47.4782 53.9027 47.4782 52.1739Z",
    fill: "#3070A0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.5217 52.1739V49.6077L38.3343 49.0028C38.542 48.9331 38.711 48.7796 38.8002 48.5796C38.8895 48.3795 38.8908 48.1512 38.8038 47.9502L36.5217 42.6832V41.2174C36.5217 35.5985 31.9667 31.0435 26.3478 31.0435C25.5569 31.0464 24.769 31.1415 24 31.3268V59.2174H30.2609V55.3043H33.3913C35.1202 55.3043 36.5217 53.9028 36.5217 52.1739Z",
    fill: "#3070A0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.9998 39.6522C42.8642 39.6522 43.565 38.9514 43.565 38.0869C43.565 37.2225 42.8642 36.5217 41.9998 36.5217C41.1353 36.5217 40.4346 37.2225 40.4346 38.0869C40.4346 38.9514 41.1353 39.6522 41.9998 39.6522Z",
    fill: "#3070A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowWith2);
export default __webpack_public_path__ + "static/media/GrowWith2.77b439f3262ca4a727a8da81d1b1def1.svg";
export { ForwardRef as ReactComponent };